import type { FC } from "react";

interface TableEmptyStateProps {
  icon: FC<{ className?: string }>;
  title: string;
  description: string;
}

export function TableEmptyState({ icon: Icon, title, description }: TableEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 px-6 py-16 text-center">
      <div className="flex size-12 items-center justify-center rounded-full border border-primary bg-primary shadow-xs">
        <Icon className="size-6 text-fg-quaternary" />
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-sm font-semibold text-primary">{title}</p>
        <p className="text-sm text-tertiary">{description}</p>
      </div>
    </div>
  );
}
